import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'

import { useDevice } from '../../contexts/DeviceContext';
import NavbarMobile from './NavbarMobile';
import NavbarDesktop from './NavbarDesktop';
import useSearch from '../../hooks/useSearch';
import { DataContext } from '../../contexts/DataContext';
import PAGES from '../../lib/pages';

export default function Navbar() {
  const [searchVisible, setSearchVisible] = useState(false);
  const { searchValue, setSearchValue, searchResults } = useSearch();
  const { isMobile } = useDevice();
  const [menuVisible, setMenuVisible] = useState(isMobile ? false : true);

  const navbarRef = useRef(null);
  const inputSearchRef = useRef(null);
  const menuRef = useRef(null);

  const { menuPages } = useContext(DataContext);
  const visiblePages = menuPages?.filter(page => Object.keys(PAGES).includes(page.title));
  visiblePages?.sort((a, b) => a.display_order - b.display_order);

  const handleClickSearchIcon = () => {
    setSearchVisible(true);
    setTimeout(() => {
      inputSearchRef.current.focus();
    }, 0);
  };

  const handleSearchInputChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleSearchBlur = () => {
    if (searchValue === '') setSearchVisible(false);
  };

  const handleBurgerClick = () => {
    setMenuVisible(!menuVisible);
  };

  const handleDocumentClick = useCallback(
    (event) => {
      if (isMobile && menuVisible && !navbarRef.current.contains(event.target)) {
        setMenuVisible(false);
      }
    }, [menuVisible, isMobile]
  );

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [menuVisible, handleDocumentClick]);

  return (
    <>
      {isMobile ? 
        <NavbarMobile
          navbarRef={navbarRef}
          searchVisible={searchVisible}
          setSearchVisible={setSearchVisible}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          inputSearchRef={inputSearchRef}
          handleSearchBlur={handleSearchBlur}
          handleSearchInputChange={handleSearchInputChange}
          handleClickSearchIcon={handleClickSearchIcon}
          handleBurgerClick={handleBurgerClick}
          menuRef={menuRef}
          menuVisible={menuVisible}
          searchResults={searchResults}
          visiblePages={visiblePages}
        /> :
        <NavbarDesktop
          navbarRef={navbarRef}
          searchVisible={searchVisible}
          setSearchVisible={setSearchVisible}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          inputSearchRef={inputSearchRef}
          handleSearchBlur={handleSearchBlur}
          handleSearchInputChange={handleSearchInputChange}
          handleClickSearchIcon={handleClickSearchIcon}
          handleBurgerClick={handleBurgerClick}
          menuRef={menuRef}
          menuVisible={menuVisible}
          searchResults={searchResults}
          visiblePages={visiblePages}
        />
      }
    </>
  )
}
